import { Box, Card, Stack, SvgIcon, Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { numberWithSpaces } from 'src/common/utils/format-utils';
import { DecreaseIcon, IncreaseIcon } from 'src/components/icons/icons';
import useStyles from './styles';

export interface StatisticsItemProps {
  icon: string;
  label: string;
  value: number;
  diffPercent: number;
  today: number;
}
interface StatisticsCardProps {
  item: StatisticsItemProps;
}
export const StatisticsCard: ComponentType<StatisticsCardProps> = ({ item }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const increased = item.diffPercent > 0;

  return (
    <Card className={classes.root} elevation={0}>
      <Stack alignItems="flex-start" direction="row" className={classes.label} mb={2}>
        <Stack className={classes.icon} alignItems="center" justifyContent="center" mr={1}>
          <img src={item.icon} alt={item.label} />
        </Stack>
        <Typography variant="body2">{item.label}</Typography>
      </Stack>
      <Typography variant="h1" mb={1} className={classes.value} color="secondary">
        {numberWithSpaces(item.value)}
      </Typography>
      <Typography variant="body3" component="div" className={classes.info}>
        <SvgIcon
          component={increased ? IncreaseIcon : DecreaseIcon}
          color={increased ? 'success' : 'error'}
          viewBox="0 0 17 17"
        />
        <Box component="span">{Math.round(item.diffPercent)}%</Box>
        <Box component="span" color="grey.400">
          {t('plusToday', '+{{count}} сегодня', { count: item.today })}
        </Box>
      </Typography>
    </Card>
  );
};
